// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var FaIcon = require("../../../shared/components/FaIcon.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var DateFns = require("../../../shared/utils/DateFns.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_option = require("rescript/lib/js/js_option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var GraphqlQuery = require("../../../shared/utils/GraphqlQuery.bs.js");
var CoursesCurriculum__Target = require("../types/CoursesCurriculum__Target.bs.js");
var CoursesCurriculum__Submission = require("../types/CoursesCurriculum__Submission.bs.js");
var CoursesCurriculum__TargetStatus = require("../types/CoursesCurriculum__TargetStatus.bs.js");
var CoursesCurriculum__TargetDetails = require("../types/CoursesCurriculum__TargetDetails.bs.js");
var CoursesCurriculum__LevelUpEligibility = require("../types/CoursesCurriculum__LevelUpEligibility.bs.js");
var CoursesCurriculum__CompletionInstructions = require("./CoursesCurriculum__CompletionInstructions.bs.js");

function str(prim) {
  return prim;
}

var ppx_printed_query = "mutation AutoVerifySubmissionMutation($targetId: ID!)  {\nautoVerifySubmission(targetId: $targetId)  {\nsubmission  {\nid  \ncreatedAt  \n}\n\nlevelUpEligibility  \n}\n\n}\n";

function parse(value) {
  var value$1 = Js_option.getExn(Js_json.decodeObject(value));
  var value$2 = Js_dict.get(value$1, "autoVerifySubmission");
  var tmp;
  if (value$2 !== undefined) {
    var value$3 = Js_option.getExn(Js_json.decodeObject(Caml_option.valFromOption(value$2)));
    var value$4 = Js_dict.get(value$3, "submission");
    var tmp$1;
    if (value$4 !== undefined) {
      var value$5 = Caml_option.valFromOption(value$4);
      var match = Js_json.decodeNull(value$5);
      if (match !== undefined) {
        tmp$1 = undefined;
      } else {
        var value$6 = Js_option.getExn(Js_json.decodeObject(value$5));
        var value$7 = Js_dict.get(value$6, "id");
        var tmp$2;
        if (value$7 !== undefined) {
          var value$8 = Caml_option.valFromOption(value$7);
          var value$9 = Js_json.decodeString(value$8);
          tmp$2 = value$9 !== undefined ? value$9 : Js_exn.raiseError("graphql_ppx: Expected string, got " + JSON.stringify(value$8));
        } else {
          tmp$2 = Js_exn.raiseError("graphql_ppx: Field id on type Submission is missing");
        }
        var value$10 = Js_dict.get(value$6, "createdAt");
        tmp$1 = {
          id: tmp$2,
          createdAt: value$10 !== undefined ? Caml_option.valFromOption(value$10) : Js_exn.raiseError("graphql_ppx: Field createdAt on type Submission is missing")
        };
      }
    } else {
      tmp$1 = undefined;
    }
    var value$11 = Js_dict.get(value$3, "levelUpEligibility");
    var tmp$3;
    if (value$11 !== undefined) {
      var value$12 = Caml_option.valFromOption(value$11);
      var match$1 = Js_json.decodeNull(value$12);
      if (match$1 !== undefined) {
        tmp$3 = undefined;
      } else {
        var value$13 = Js_json.decodeString(value$12);
        var tmp$4;
        if (value$13 !== undefined) {
          switch (value$13) {
            case "AtMaxLevel" :
                tmp$4 = "AtMaxLevel";
                break;
            case "CurrentLevelIncomplete" :
                tmp$4 = "CurrentLevelIncomplete";
                break;
            case "DateLocked" :
                tmp$4 = "DateLocked";
                break;
            case "Eligible" :
                tmp$4 = "Eligible";
                break;
            case "NoMilestonesInLevel" :
                tmp$4 = "NoMilestonesInLevel";
                break;
            case "PreviousLevelIncomplete" :
                tmp$4 = "PreviousLevelIncomplete";
                break;
            case "TeamMembersPending" :
                tmp$4 = "TeamMembersPending";
                break;
            default:
              tmp$4 = Js_exn.raiseError("graphql_ppx: Unknown enum variant for LevelUpEligibility: " + value$13);
          }
        } else {
          tmp$4 = Js_exn.raiseError("graphql_ppx: Expected enum value for LevelUpEligibility, got " + JSON.stringify(value$12));
        }
        tmp$3 = tmp$4;
      }
    } else {
      tmp$3 = undefined;
    }
    tmp = {
      submission: tmp$1,
      levelUpEligibility: tmp$3
    };
  } else {
    tmp = Js_exn.raiseError("graphql_ppx: Field autoVerifySubmission on type Mutation is missing");
  }
  return {
          autoVerifySubmission: tmp
        };
}

function make(targetId, param) {
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray([[
                    "targetId",
                    targetId
                  ]].filter(function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  })),
          parse: parse
        };
}

function makeWithVariables(variables) {
  var targetId = variables.targetId;
  return {
          query: ppx_printed_query,
          variables: Js_dict.fromArray([[
                    "targetId",
                    targetId
                  ]].filter(function (param) {
                    return !Js_json.test(param[1], /* Null */5);
                  })),
          parse: parse
        };
}

function makeVariables(targetId, param) {
  return Js_dict.fromArray([[
                  "targetId",
                  targetId
                ]].filter(function (param) {
                  return !Js_json.test(param[1], /* Null */5);
                }));
}

function definition_2(graphql_ppx_use_json_variables_fn, targetId, param) {
  return Curry._1(graphql_ppx_use_json_variables_fn, Js_dict.fromArray([[
                      "targetId",
                      targetId
                    ]].filter(function (param) {
                      return !Js_json.test(param[1], /* Null */5);
                    })));
}

var definition = [
  parse,
  ppx_printed_query,
  definition_2
];

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var AutoVerifySubmissionQuery = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  make: make,
  makeWithVariables: makeWithVariables,
  makeVariables: makeVariables,
  definition: definition,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

function redirect(link) {
  var $$window$1 = window;
  $$window$1.open(link, "_blank", "");
  
}

function handleSuccess(submission, levelUpEligibility, linkToComplete, addSubmissionCB) {
  Curry._2(addSubmissionCB, CoursesCurriculum__Submission.make(submission.id, DateFns.decodeISO(submission.createdAt), /* MarkedAsComplete */0, []), levelUpEligibility);
  if (linkToComplete !== undefined) {
    return redirect(linkToComplete);
  }
  
}

function createAutoVerifySubmission(target, linkToComplete, setSaving, addSubmissionCB, $$event) {
  $$event.preventDefault();
  Curry._1(setSaving, (function (param) {
          return true;
        }));
  GraphqlQuery.sendQuery(undefined, make(CoursesCurriculum__Target.id(target), undefined)).then(function (response) {
        var details = response.autoVerifySubmission.submission;
        if (details !== undefined) {
          var levelUpEligibility = CoursesCurriculum__LevelUpEligibility.makeOptionFromJs(response.autoVerifySubmission.levelUpEligibility);
          handleSuccess(Caml_option.valFromOption(details), levelUpEligibility, linkToComplete, addSubmissionCB);
        } else {
          Curry._1(setSaving, (function (param) {
                  return false;
                }));
        }
        return Promise.resolve(undefined);
      });
  
}

function completeButtonText(title, iconClasses) {
  return React.createElement("span", undefined, React.createElement(FaIcon.make, {
                  classes: iconClasses + " mr-2"
                }), title);
}

function previewLinkToComplete(link) {
  return React.createElement("a", {
              className: "block text-primary-500 w-full text-center bg-gray-200 hover:bg-gray-300 hover:text-primary-600 p-4 rounded text-lg font-bold",
              href: link,
              target: "_blank"
            }, React.createElement("span", undefined, React.createElement(FaIcon.make, {
                      classes: "fas fa-external-link-alt mr-2"
                    }), "Visit Link "));
}

function autoVerify(target, linkToComplete, saving, setSaving, addSubmissionCB, preview) {
  if (preview && linkToComplete !== undefined) {
    return previewLinkToComplete(linkToComplete);
  }
  return React.createElement("button", {
              className: "flex rounded btn-success text-lg justify-center w-full font-bold p-4  ",
              disabled: saving || preview,
              onClick: (function (param) {
                  return createAutoVerifySubmission(target, linkToComplete, setSaving, addSubmissionCB, param);
                })
            }, saving ? completeButtonText("Saving", "fas fa-spinner fa-spin") : (
                linkToComplete !== undefined ? completeButtonText("Visit Link To Complete", "fas fa-external-link-alt") : completeButtonText("Mark As Complete", "fas fa-check-square")
              ));
}

function statusBar(string, linkToComplete) {
  var message = React.createElement("div", {
        className: "flex items-center"
      }, React.createElement("span", {
            className: "fa-stack text-lg mr-1 text-green-500"
          }, React.createElement("i", {
                className: "fas fa-certificate fa-stack-2x"
              }), React.createElement("i", {
                className: "fas fa-check fa-stack-1x fa-inverse"
              })), React.createElement("span", undefined, string));
  var visitLink = function (link) {
    return React.createElement("a", {
                className: "text-right w-full",
                href: link,
                target: "_blank"
              }, React.createElement("i", {
                    className: "fas fa-external-link-alt mr-2"
                  }), "Visit Link");
  };
  return React.createElement("div", {
              className: "font-bold p-4 flex w-full items-center text-green-500 bg-green-100 justify-center"
            }, message, linkToComplete !== undefined ? visitLink(linkToComplete) : null);
}

function completionInstructionText(linkToComplete) {
  if (linkToComplete !== undefined) {
    return "Before visiting the link...";
  } else {
    return "Before marking as complete...";
  }
}

function CoursesCurriculum__AutoVerify(Props) {
  var target = Props.target;
  var targetDetails = Props.targetDetails;
  var targetStatus = Props.targetStatus;
  var addSubmissionCB = Props.addSubmissionCB;
  var preview = Props.preview;
  var match = React.useState(function () {
        return false;
      });
  var linkToComplete = CoursesCurriculum__TargetDetails.linkToComplete(targetDetails);
  var match$1 = CoursesCurriculum__TargetStatus.status(targetStatus);
  return [
          React.createElement(CoursesCurriculum__CompletionInstructions.make, {
                targetDetails: targetDetails,
                title: completionInstructionText(linkToComplete),
                key: "completion-instructions"
              }),
          React.createElement("div", {
                key: "completion-button",
                className: "mt-5",
                id: "auto-verify-target"
              }, typeof match$1 === "number" ? (
                  match$1 !== 0 ? statusBar("Completed", linkToComplete) : autoVerify(target, linkToComplete, match[0], match[1], addSubmissionCB, preview)
                ) : null)
        ];
}

var TargetStatus;

var make$1 = CoursesCurriculum__AutoVerify;

exports.str = str;
exports.TargetStatus = TargetStatus;
exports.AutoVerifySubmissionQuery = AutoVerifySubmissionQuery;
exports.redirect = redirect;
exports.handleSuccess = handleSuccess;
exports.createAutoVerifySubmission = createAutoVerifySubmission;
exports.completeButtonText = completeButtonText;
exports.previewLinkToComplete = previewLinkToComplete;
exports.autoVerify = autoVerify;
exports.statusBar = statusBar;
exports.completionInstructionText = completionInstructionText;
exports.make = make$1;
/* react Not a pure module */
